import { MapReducer } from "./map";
import { ConfirmReducer } from './confirm-controller';

export const ControllerMiddlewares = [];

export const ControllerReducers = {
  MapReducer,
  ConfirmReducer,
};
